<template>
    <LoadingFrame />
    <div class="fixed left-0 top-0 h-full w-full bg-primary-orange"></div>
    <Search />
    <Header />
    <main
        class="overflow-x-hidden bg-base-bgGrey font-bold lg:px-10 lg:pt-[119px]"
    >
        <!-- 使用元件 Hero.vue -->
        <slot name="hero" />

        <section class="content-indent pt-12 lg:pt-[100px] xl:pt-[120px]">
            <slot name="wrapper-content" />
        </section>

        <slot name="container-content" />
    </main>
    <Footer />
</template>

<style scoped>
.content-indent {
    @apply mx-auto w-[92.1vw] max-w-[948px] sm:w-[92vw] lg:w-[69.3vw];
}
</style>
